export const SDK_TURBO_PLACE_ORDER_TIMEOUT_IN_MINS = 15; // 15 mins
